import { defineStore } from 'pinia';
import { LxAppStore } from '@dativa-lv/lx-ui';

export default defineStore('appStore', LxAppStore);
